const MAX_EVENTS = 20;

function ensureStore() {
  if (typeof window === 'undefined') return [];
  if (!Array.isArray(window.__FASTTIME_SUPPORT_CONSOLE__)) {
    window.__FASTTIME_SUPPORT_CONSOLE__ = [];
  }
  return window.__FASTTIME_SUPPORT_CONSOLE__;
}

function normalizeMessage(args) {
  return args.map((value) => {
    if (typeof value === 'string') return value;
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }).join(' ').slice(0, 4000);
}

function pushEvent(event) {
  const store = ensureStore();
  store.push({
    level: event.level || 'log',
    message: (event.message || '').slice(0, 4000),
    source: event.source || null,
    timestamp: event.timestamp || new Date().toISOString(),
  });
  if (store.length > MAX_EVENTS) {
    store.splice(0, store.length - MAX_EVENTS);
  }
}

export function installBrowserConsoleCapture() {
  if (typeof window === 'undefined') return;
  if (window.__FASTTIME_SUPPORT_CONSOLE_INSTALLED__) return;
  window.__FASTTIME_SUPPORT_CONSOLE_INSTALLED__ = true;

  ['error', 'warn'].forEach((level) => {
    const original = console[level];
    console[level] = (...args) => {
      pushEvent({
        level,
        message: normalizeMessage(args),
        source: 'console',
      });
      return original.apply(console, args);
    };
  });

  window.addEventListener('error', (event) => {
    pushEvent({
      level: 'error',
      message: event.message || 'Unhandled browser error',
      source: event.filename || 'window.error',
      timestamp: event.timeStamp ? new Date(event.timeStamp).toISOString() : new Date().toISOString(),
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    pushEvent({
      level: 'error',
      message: reason instanceof Error ? reason.message : normalizeMessage([reason]),
      source: 'unhandledrejection',
    });
  });
}

export function getRecentBrowserConsoleEvents() {
  return ensureStore().slice(-MAX_EVENTS);
}
